// extracted by mini-css-extract-plugin
module.exports = {"subdescription":"PagePresentation_subdescription__6Xe5_","frameText":"PagePresentation_frameText__3Zydx","link":"PagePresentation_link__SVhVP"};